import { render, staticRenderFns } from "./DVideoWatermarkTemplate.vue?vue&type=template&id=09af0d5b&scoped=true&"
import script from "./DVideoWatermarkTemplate.vue?vue&type=script&lang=js&"
export * from "./DVideoWatermarkTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DVideoWatermarkTemplate.vue?vue&type=style&index=0&id=09af0d5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af0d5b",
  null
  
)

export default component.exports